import axios from "axios";
export const upload = (file) => {
  const formData = new FormData();
  formData.append("file", file);
  let token =  localStorage.getItem('token');
  return new axios({
    method: "post",
    url: "https://train.nchvc.edu.cn/web/upload",
    data: formData,
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "multipart/form-data",
    },
  })
    .then((res) => {
      if (res.data && res.data.code === 0) {
        return res.data.data;
      } else {
        return "";
      }
    })
    .catch((err) => {
      return "";
    });
};